import React from "react";
import { T } from "react-translator-component";
import {
  Button,
  Dialog, DialogContent, DialogTitle, DialogProps,
} from "@mui/material";
import { colors } from "../../common/colors";
import { mngStyles } from "../constants/styles";
import SubmitButton from "../../components/SubmitButton";

interface Props extends DialogProps {
  message: string;
  validate: () => Promise<boolean>;
  onSubmit: () => Promise<boolean>;
  onClose?: () => void;
}

const DeleteConfirmationDialog: React.FC<Props> = ({ message, validate, onSubmit, onClose, ...rest }: Props) => {
  return (
    <Dialog onClose={onClose} disableRestoreFocus={true} closeAfterTransition={true} {...rest}>
      <DialogTitle sx={styles.title}>
        {message}
      </DialogTitle>
      <DialogContent>
        <div style={mngStyles.adminUserDialogContent}>
          <SubmitButton
            onSubmit={onSubmit} // Trigger delete action with the stored ID if it's not null
            variant="contained"
            color={"error"}
            sx={styles.submitButton}
            validate={validate}
          >
            {T("mng_delete")}
          </SubmitButton>

          <Button
            onClick={onClose}
            variant="contained"
            sx={styles.cancelButton}
          >
            {T("mng_cancel")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DeleteConfirmationDialog

const styles = {
  title: {
    ...mngStyles.adminUserDialogTitle,
    color: colors.farm_red600,
    textAlign: "center",
  },
  submitButton: {
    marginRight: 5,
    textAlign: "center"
  },
  cancelButton: {
    textAlign: "center",
    backgroundColor: "#fea501",
  }
}
